<template>
	<div v-if="getFeedbackEntry" :class="buttonClass" @click="handleFeedback">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons name="icon_feedback" class="c-action-svg" />
			<span class="action-block-span">{{ getModuleName('leave_word') }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<SvgIcons name="icon_feedback" class="mobile-action-svg" />
		</template>

		<CTeleport to="#app">
			<!-- PC端弹窗 -->
			<CDialogFeedback v-if="mode === 'pc'" :visible.sync="visibleFeedback" />
		</CTeleport>
	</div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useCommonData } from '@/hooks';
import { useModuleDisplay } from '../hooks/useModuleDisplay.js';
import { debounce } from '@/utils/api';
import CDialogFeedback from '@/rebuild/materials/shared/leave_word/CDialogFeedback.vue';

const mode = inject('mode');
const buttonClass = inject('roundButtonClass');

const { getFeedbackEntry, getModuleName, trackAction } = useModuleDisplay();

// 弹窗状态
const visibleFeedback = ref(false);

const { generateMobileModuleUrl } = useCommonData();

// 点击处理
const handleFeedback = debounce(
	() => {
		trackAction('feedback');

		if (mode === 'mobile') {
			// 移动端跳转
			const feedbackUrl = generateMobileModuleUrl('leave_word', { f: 'PC' });
			window.open(feedbackUrl, '_blank');
		} else {
			// PC端显示弹窗
			visibleFeedback.value = true;
		}
	},
	200,
	true
);
</script>
